import PosOperations from '@domains/pos-operations/views/PosOperations.vue'

export default [
  {
    path: 'pos-operations',
    component: PosOperations,
    name: 'PosOperations',
    props: (route) => ({
      search: route.query.search,
      status: route.query.status,
      type: route.query.type,
      closedAt: route.query.closedAt,
      id: route.query.id
    })
  }
]
